import HOCWatchValue from 'components/common/hoc-watch-value';
import Separator from 'components/common/separator';
import Text from 'components/elements/text';
import * as React from 'react';

import ActivityPurchaseGuestDetailTable from './item-table';

interface Props {
  parentIndex: number;
}

export default function ActivityPurchaseItem(props: Props) {
  const _values = HOCWatchValue({
    keys: [`approvalable.activityPurchases.${props.parentIndex}`],
  });
  const { isGroupedPrice, activityPurchaseGuests } =
    _values[`approvalable.activityPurchases.${props.parentIndex}`];

  if (!activityPurchaseGuests.length) {
    return <></>;
  }

  if (isGroupedPrice) {
    return (
      <ActivityPurchaseGuestDetailTable
        parentIndex={props.parentIndex}
        guestIndex={0}
      />
    );
  }

  return (
    <>
      {activityPurchaseGuests.map((field, idx) => (
        <React.Fragment key={field.id}>
          <Separator gap={16} />
          <Text variant="ParagraphSmall">{field.guestName || '-'}</Text>
          <Separator gap={16} />
          <ActivityPurchaseGuestDetailTable
            parentIndex={props.parentIndex}
            guestIndex={idx}
          />
        </React.Fragment>
      ))}
    </>
  );
}
